import React, { useState, useEffect } from 'react'
import { Card, CardBody } from 'reactstrap'

import ListTopBar from '../../components/ListTopBar'

import OpensTable from './partials/OpensTable'

import { handleError, parsePagination } from '../../helpers'
import { getOpens } from './services'

export default function OpensList() {
	const [opens, setOpens] = useState(null)
	const [filterType, setFilterType] = useState('model.name')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})

	useEffect(() => {
		!opens && getOpens({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			include: 'model,user',
			sort: '-created_at'
		})
			.then(res => {
				setOpens(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ opens, pagination, filterType, filterValue ])

	return (
		<React.Fragment>
			<ListTopBar 
				title="Registros de Aperturas"
				subtitle="Listado de todos las aperturas registradas en la plataforma"
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setOpens(null)}
				options={[
					{ label: 'Buscar titulo de apertura', value: 'model.name' },
					{ label: 'Buscar por cedula del usuario', value: 'user.document' }
				]}
			/>
			<Card>
				<CardBody>
					<OpensTable 
						opens={opens}
						pagination={pagination}
						setPagination={setPagination}
						reload={() => setOpens(null)}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}